import React, { useEffect, useState } from 'react';
import { Circle } from 'react-feather';
import { Smartphone, Globe, XCircle } from 'react-feather';
import styles from './styles.module.scss';
import { getCssVar } from '@/utils/cssVars';
import { IContentColors } from '@/types';
import api from '@/api';
import { useParams, useLocation } from 'react-router-dom';

const LoggedDevices = ({ handleUpdateDevice }) => {
  const [devicesList, setDevicesList] = useState([]);
  const { eventId = '' } = useParams<{ eventId: string }>();

  useEffect(() => {
    api.account
      .getActiveUserSessions(eventId)
      .then(({ data }) => {
       setDevicesList(data);
      })
      .catch(error => {
        //DO SOMETHING
      });
  }, [eventId]);

  const handleDelete = id => {
    const devicesListNew = devicesList.filter(item => item.userSessionId !== id);
    setDevicesList(devicesListNew);
    api.account
      .inValidateUserSession(eventId, id);
      handleUpdateDevice(devicesListNew.length);
  };

  return (
    <div className={styles.deviceContainer}>
      {devicesList.map(device => (
        <LoggedDevice
          key={device.userSessionId}
          device={device}
          handleDelete={handleDelete}
        />
      ))}
    </div>
  );
};

const LoggedDevice = ({ device, handleDelete }) => {
  const DeviceIcon = device.isMobile && Smartphone || Globe
  return (
    <div>
      <table className={styles.device}>
        <tr>
          <td className={styles.deviceIcon}><DeviceIcon/></td>
          <td className={styles.deviceName}>{device.deviceName}</td>
          <td className={styles.crossIcon}>
            <XCircle
              size="15px"
              color={getCssVar(IContentColors.DANGER)}
              onClick={() => handleDelete(device.userSessionId)}
            />
          </td>
        </tr>
      </table>
    </div>
  );
};

export default LoggedDevices;
